import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastMessage {
    message: string;
    header?: string;
    variant: 'confirmation' | 'error' | 'warning' | 'info';
    visible: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private toastSubject = new BehaviorSubject<ToastMessage>({
        message: '',
        header: '',
        variant: 'confirmation',
        visible: false
    });

    toast$ = this.toastSubject.asObservable();
    private autoHideTimeout?: ReturnType<typeof setTimeout>;

    showSuccess(message: string, header = $localize`Successful`) {
        this.clearAutoHide();
        this.toastSubject.next({
            message,
            header,
            variant: 'confirmation',
            visible: true
        });
        this.setAutoHide();
    }

    showError(message: string, header = $localize`Error`) {
        this.clearAutoHide();
        this.toastSubject.next({
            message,
            header,
            variant: 'error',
            visible: true
        });
        this.setAutoHide();
    }

    hide() {
        this.clearAutoHide();
        this.toastSubject.next({
            ...this.toastSubject.value,
            visible: false
        });
    }

    private setAutoHide() {
        this.autoHideTimeout = setTimeout(() => {
            this.hide();
        }, 8000);
    }

    private clearAutoHide() {
        if (this.autoHideTimeout) {
            clearTimeout(this.autoHideTimeout);
            this.autoHideTimeout = undefined;
        }
    }
}
